<template>
    <div class="prompt" @click.stop :class="{show: likes.length > 0}">
        <div class="prompt-body" v-if="likes.length > 0">
            <div
                @click="openUser(like.author.id)"
                class="prompt-item"
                v-for="like in getLikes()"
                :key="like.id"
                :style="{backgroundImage: `url('${like.author.avatar}')`}"
                :title="like.author.firstname"
            ></div>
            <div class="prompt-more" @click="setUsers()" v-if="likes.length > 3">
                <p>+{{ likes.length - 3}}</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Prompt',
    props: {
        likes: {
            type: Array,
            require: true
        }
    },
    methods: {
        openUser(id) {
            this.$router.push({name: 'user', params: {id}})
        },
        getLikes() {
            return this.likes.slice(0, 3)
        },
        setUsers() {
            let users = [];
            this.likes.forEach(like => {
                users.push(like.author)
            });
            this.$store.dispatch('setModalUsers', users)
        }
    }
}
</script>
<style lang="stylus" scoped>
.prompt
    position absolute
    // top calc(100% + 10px)
    top 100%
    left 0
    padding-top 10px
    opacity 0
    z-index -1
    transition 0.3s all
    display none
    &.show
        pointer-events all
        display block

    &:hover
        pointer-events all
        opacity 1
    &:before
        content ''
        position absolute
        left 15px
        top 2px
        width 0 
        height 0
        border-left 8px solid transparent
        border-right 8px solid transparent
        border-bottom 8px solid #f0f0f0

    &-body
        display flex
        align-items center
        background-color #f0f0f0
        border 1px solid #eaeaea
        padding 7px
        border-radius 10px

    &-item
        width 40px
        height 40px
        border-radius 50%
        margin 0 3px
        background-color #333
        background-size cover
    
    &-more
        height 40px
        padding 0 12px
        border-radius 8px
        margin 0 3px
        color white
        display flex
        align-items center
        justify-content center
        background-color #222
        font-size 12px
        font-weight 500
</style>